// BadgeContainer.js
import React from 'react';
import Badge from './Badge';
import { faRocket, faCheckCircle, faFlag, faTrophy, faEye, faClock, faChartLine, faHourglassEnd, faLightbulb, faCrown } from '@fortawesome/free-solid-svg-icons';

const BadgeContainer = () => {
  const badges = [
    { id: 'newbie-nudger', icon: faRocket, bgColor: '#7cb342' },
    { id: 'task-tackler', icon: faCheckCircle, bgColor: '#42a5f5' },
    { id: 'project-pioneer', icon: faFlag, bgColor: '#ab47bc' },
    { id: 'goal-getter', icon: faTrophy, bgColor: '#ef5350' },
    { id: 'focus-fanatic', icon: faEye, bgColor: '#26a69a' },
    { id: 'time-tamer', icon: faClock, bgColor: '#ffca28' },
    { id: 'efficiency-expert', icon: faChartLine, bgColor: '#8d6e63' },
    { id: 'deadline-dominator', icon: faHourglassEnd, bgColor: '#66bb6a' },
    { id: 'productivity-prodigy', icon: faLightbulb, bgColor: '#ec407a' },
    { id: 'master-motivator', icon: faCrown, bgColor: '#5c6bc0' },
  ];

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  };

  return (
    <div className="badge-container" style={containerStyle}>
      {badges.map((badge) => (
        <Badge key={badge.id} id={badge.id} icon={badge.icon} bgColor={badge.bgColor} />
      ))}
    </div>
  );
};

export default BadgeContainer;
